import {NgModule} from "@angular/core";
import {FeatureFlagDirective} from "./featureFlag.directive";
import {TitleDirective} from "./title.directive";

@NgModule({
  declarations: [FeatureFlagDirective, TitleDirective],
    exports: [FeatureFlagDirective, TitleDirective]
})
export class DirectiveModule {}